import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class WhatsBsuite {
  constructor() {
    this.main = document.getElementById('whats_bsuite');
    this._sectionIntro = this.main.querySelector('.section--intro');
    this._sectionBaudience = this.main.querySelector('.section--baudience');
    this._sectionBcreative = this.main.querySelector('.section--bcreative');
    this._sectionBcampaigns = this.main.querySelector('.section--bcampaigns');

    this.setIntroTimeline();
    this.setBaudienceTimeline();
    this.setBcreativeTimeline();
    this.setBcampaignsTimeline();
  }
  
  setIntroTimeline(){
    this._dashboardCards = this.main.querySelectorAll('.dash-card');
    this.tlIntro = gsap.timeline();
    this.mySTIntro = ScrollTrigger.create({
      animation: this.tlIntro,
      trigger: this._sectionIntro,
      start: "20% 20%",
      end: "bottom 50%",
      scrub: 1,
      markers: false //true for debug
    });
    this.tlIntro.set(this._dashboardCards,{opacity: 0, y: 100},0);
    this.tlIntro
      .to(this._sectionIntro.querySelector('.campaign-dashboard'), { opacity: 1, duration: 0.3 })
      .to(this._dashboardCards, {y: 0, opacity: 1 },'dashboard')
      .to(this._sectionIntro.querySelector('.line-a'), { strokeDasharray: 2200 }, 'dashboard')
      .to(this._sectionIntro.querySelector('.line-b'), { strokeDasharray: 2200 }, 'dashboard')
      .to(this._sectionIntro.querySelector('.line-a-shadow'), { opacity: 1 , duration: 0.2 });
  }

  setBaudienceTimeline(){
    this.tlBaudience = gsap.timeline();
    this.mySTBaudience = ScrollTrigger.create({
      animation: this.tlBaudience,
      trigger: this._sectionBaudience,
      start: "top 50%",
      end: "bottom bottom",
      scrub: 1,
      markers: false //true for debug
    });
    this.tlBaudience.set(this._sectionBaudience.querySelector('.tooltip'),{opacity: 0, rotation: 30, scale:0.3, transformOrigin:'center center'},0);
    this.tlBaudience.to(this._sectionBaudience.querySelector('.tooltip'), { scale: 1, rotation:0, opacity:1, duration: 3 });
  }

  setBcreativeTimeline(){
    this.tlBcreative = gsap.timeline();
    this.tlBcreativeInputTile = gsap.timeline({repeat: -1});
    this.mySTBcreative = ScrollTrigger.create({
      animation: this.tlBcreative,
      trigger: this._sectionBcreative,
      start: "20% 50%",
      end: "80% 50%",
      scrub: 1,
      markers: false //true for debug
    });

    this.tlBcreativeInputTile.fromTo(this._sectionBcreative.querySelector('.input-tile'),{autoAlpha:0},{autoAlpha:1},0.2);

    this.tlBcreative.set(this._sectionBcreative.querySelector('.icon-ia'),{autoAlpha: 0, rotation: -165, scale:0.3, transformOrigin:'center center'});
    this.tlBcreative.set(this._sectionBcreative.querySelector('.icon-layout'),{autoAlpha: 0, rotation: -165, scale:0.3, transformOrigin:'center center'});
    this.tlBcreative.set(this._sectionBcreative.querySelector('.icon-paint'),{autoAlpha: 0, rotation: -165, scale:0.3, transformOrigin:'center center'});
    this.tlBcreative.set(this._sectionBcreative.querySelector('.input-mask'),{width: '40%', x: '0%'});
    this.tlBcreative.set(this._sectionBcreative.querySelector('.input-tile'),{ x: -280});

    this.tlBcreative.to(this._sectionBcreative.querySelector('.icon-ia'),{autoAlpha: 1, rotation: 0, scale:1},'icons')
    .to(this._sectionBcreative.querySelector('.icon-layout'),{autoAlpha: 1, rotation: 0, scale:1, delay: 0.2},'icons')
    .to(this._sectionBcreative.querySelector('.icon-paint'),{autoAlpha: 1, rotation: 0, scale:1, delay: 0.4},'icons')
    .to(this._sectionBcreative.querySelector('.input-mask'),{width: '0%', x: 290},'input')
    .to(this._sectionBcreative.querySelector('.input-tile'),{x: 0},'input')
    
  }

  setBcampaignsTimeline(){
    this._analyticsCards = this._sectionBcampaigns.querySelectorAll('.card');
    this.tlBcampaigns = gsap.timeline();
    this.mySTBcampaigns = ScrollTrigger.create({
      animation: this.tlBcampaigns,
      trigger: this._sectionBcampaigns,
      start: "10% 50%",
      end: "80% 50%",
      scrub: 1,
      markers: false //true for debug
    });

    this.tlIntro.set(this._analyticsCards,{opacity: 0, y: 100},0);

    this.tlBcampaigns.to(this._sectionBcampaigns.querySelector('.line-a'), { strokeDashoffset: 0 },'start')
    .to(this._analyticsCards, {y: 0, opacity: 1, stagger:0.2 },'start')
  }

}

export default WhatsBsuite;
